var _defs, _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWebAccessibilityEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#036;}.cls-2{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 75,
    cy: 75,
    r: 75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,103.93c-22.6,0-41.46-19.78-46.71-25.85a4.93,4.93,0,0,1,0-6.16C33.54,65.85,52.4,46.07,75,46.07s41.46,19.78,46.71,25.85h0a4.93,4.93,0,0,1,0,6.16C116.46,84.15,97.6,103.93,75,103.93Zm0-53.86c-20.9,0-38.72,18.72-43.68,24.46a1.1,1.1,0,0,0,0,.94C36.28,81.2,54.1,99.93,75,99.93s38.72-18.73,43.68-24.46a1.1,1.1,0,0,0,0-.94C113.72,68.79,95.9,50.07,75,50.07Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M75,93.56c-10.57,0-19.17-8.33-19.17-18.56S64.43,56.44,75,56.44,94.17,64.77,94.17,75,85.57,93.56,75,93.56Zm0-33.12C66.63,60.44,59.83,67,59.83,75S66.63,89.56,75,89.56,90.17,83,90.17,75,83.37,60.44,75,60.44Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.41,76a2,2,0,0,1-2-2,3.74,3.74,0,0,0-3.79-3.58,3.91,3.91,0,0,0-1.51.3A2,2,0,0,1,72.58,67a7.92,7.92,0,0,1,3-.6A7.69,7.69,0,0,1,83.41,74,2,2,0,0,1,81.41,76Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAccessibilityEye);
export default __webpack_public_path__ + "static/media/web-accessibility-eye.166c9712c879e75b26c78460285be646.svg";
export { ForwardRef as ReactComponent };